/*
 * @Description: 初始化首屏数据
 * @Author: fiveonelei
 * @Date: 2022-03-30 16:23:01
 * @FilePath: /app-monorepo-projects/packages/app-share/src/composable/use-initialize-home-data/index.ts
 */
import { MyStore, useStore } from '@/store';
import useInitializeInSsr from './use-init-ssr';
import useInitializeInCsr from './use-init-csr';
import useInitPageConfig from './use-init-pageconfig';

/**
 * 判断是否有feed数据
 *
 * @param {MyStore} store
 * @return {Boolean}
 */
function checkIsFeedDataExisted(store: MyStore) {
  return Boolean(store.state.feedsList.length);
}

export default function useInitializeHomeData() {
  const store = useStore();
  const { initializeInCsr, initializeShareStrategy } = useInitializeInCsr();
  const { initPageConfig } = useInitPageConfig();
  const initializeInSsr = useInitializeInSsr();
  // 先初始化服务端传下来的数据
  initializeInSsr();
  /**
   * @description: 初始化首屏数据
   */
  async function initializeHomeData() {
    const isFeedDataExisted = checkIsFeedDataExisted(store);
    // 如果存在feed，那么服务端已经初始化好feed或banner相关数据了，只需要初始化分享策略数据
    if (isFeedDataExisted) {
      // 初始化分享策略数据
      await initializeShareStrategy();
    } else {
      // 在csr中初始化所有页面依赖的数据
      await initializeInCsr();
    };
    // 初始化页面配置
    initPageConfig();
  }
  return {
    initializeHomeData,
  };
}
